import React, { Component } from 'react'
import './bonus.css'

export default class BonusComponent extends Component {
  render() {
    return (
      <div className="gifContainer">
        <h2>Empiezas hoy y recibes GRATIS</h2>
        <div className="grid">
          <article className="cardgift">
            <div className="emoji" aria-hidden="true">
              🎁
            </div>
            <div className="cardgift-content">
              <div className="cardgift-title">
                <h3>Guía de sustitución de alimentos</h3>
                <div className="price">$69</div>
              </div>
              <p className="desc">
                Para que puedas variar tus comidas sin salirte del protocolo.
                Alternativas simples para proteínas, carbohidratos, grasas y
                vegetales.
              </p>
            </div>
          </article>

          <article className="cardgift ribbon">
            <div className="emoji" aria-hidden="true">
              🎁
            </div>
            <div className="cardgift-content">
              <div className="cardgift-title">
                <h3>Guía de suplementación esencial</h3>
                <div className="price">$47</div>
              </div>
              <p className="desc">
                Qué sirve, qué no sirve, qué puedes usar si quieres acelerar, y
                qué evitar para no inflamarse más.
              </p>
            </div>
          </article>

          <article className="cardgift">
            <div className="emoji" aria-hidden="true">
              🎁
            </div>
            <div className="cardgift-content">
              <div className="cardgift-title">
                <h3>Guía de compras antiinflamatorias</h3>
                <div className="price">$30</div>
              </div>
              <p className="desc">
                Cómo hacer una compra saludable sin gastar de más. La lista
                exacta para llenar tu nevera con alimentos que desinflaman.
              </p>
            </div>
          </article>

          <article className="cardgift">
            <div className="emoji" aria-hidden="true">
              🎁
            </div>
            <div className="cardgift-content">
              <div className="cardgift-title">
                <h3>Guía de analíticas esenciales</h3>
                <div className="price">$29</div>
              </div>
              <p className="desc">
                Una guía de analíticas de sangre de 30 parámetros esenciales
                para conocer a fondo tu salud hormonal, metabólica e
                inflamatoria.
              </p>
            </div>
          </article>
        </div>
        <div class="offer-highlight">
          <p class="real-price">
            Total real: <span>$175 USD</span>
          </p>
          <p class="free-today">✨ Hoy incluidos GRATIS ✨</p>
        </div>
      </div>
    )
  }
}
